// close_webview - Close the current window in Webveiw
// open_webview - Open a new window in Webveiw
// login - login action in app
export const WebViewActions = {
  CLOSE_WEBVIEW: 'close_webview',
  LOGIN: 'login',
  OPEN_WEBVIEW: 'open_webview',
  OPEN_DEEPLINK: 'open_deeplink',
  INTENT: 'intent',
}

interface IWebviewParams {
  url?: string
  action: string
}

// Function for executing callback using js-interface when the page is running withing android/iOS App
export const callWebviewHandler = ({ url, action }: IWebviewParams) => {
  const webViewData = url ? { action, action_value: { url } } : { action }
  const stringWebViewData = JSON.stringify(webViewData)
  if ((window as any).flutter_inappwebview?.callHandler) {
    ;(window as any).flutter_inappwebview.callHandler('WebViewConnect', stringWebViewData)
  }
}

export const callWebviewHandlerV2 = ({ url, action }: IWebviewParams) => {
  const webViewData = url ? { action, action_value: url } : { action }
  const stringWebViewData = JSON.stringify(webViewData)
  if ((window as any).flutter_inappwebview?.callHandler) {
    ;(window as any).flutter_inappwebview.callHandler('WebViewConnect', stringWebViewData)
  }
}
